<!-- FOOTER -->
<footer class="footer">
  <div class="container">
    <div class="row align-items-center flex-row-reverse">
      <div class="col-md-12 col-sm-12 text-center">
        Copyright © <a href="javascript:void(0);">Tax Canary</a>. All
        rights reserved.
      </div>
    </div>
  </div>
</footer>
<!-- FOOTER CLOSED -->
